import { createSlice } from '@reduxjs/toolkit';

export const adminClientRedactionData = createSlice({
  name: 'adminClientRedactionData',
  initialState: {
    redactions: [], // Liste des rédactions créées
    currentRedaction: null, // Rédaction en cours de création
  },
  reducers: {
    addRedaction: (state, { payload }) => {
      const newRedaction = {
        id: Date.now(), // ID temporaire
        title: payload.keyword,
        keyword: payload.keyword,
        url: payload.url,
        keywords: payload.keywords,
        semanticGap: payload.semanticGap,
        internalLinking: payload.internalLinking,
        status: 'CREATED',
        createdAt: new Date().toISOString(),
      };
      state.redactions.push(newRedaction);
    },
    setCurrentRedaction: (state, { payload }) => {
      state.currentRedaction = payload;
    },
    clearCurrentRedaction: (state) => {
      state.currentRedaction = null;
    },
    deleteRedaction: (state, { payload }) => {
      state.redactions = state.redactions.filter(redaction => redaction.id !== payload);
    },
    clearAdminClientRedactionData: (state) => {
      state.redactions = [];
      state.currentRedaction = null;
    },
  },
});

export const { addRedaction, setCurrentRedaction, clearCurrentRedaction, deleteRedaction, clearAdminClientRedactionData } = adminClientRedactionData.actions;
export const adminClientRedactionDataSelector = (state) => state.adminClientRedactionData;

export default adminClientRedactionData.reducer;
